module.exports = __webpack_public_path__ + "img/line_3.df35fa97.png";